export default __webpack_public_path__ + "static/media/26 Track 26.6f515d13.mp3";